<template>
  <div class="outer-wrapper">
    <div class="button-wrapper">
      <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
        >打印</Button
      >
    </div>
    <div id="to_single_print">
    <div class="content" >
      <div class="inner">
        <p class="table-no">表号：{{ value.formNo }}</p>
        <p class="comnamech">上海赛恩工贸有限公司</p>
        <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
        <p class="title">水压试验报告</p>
        <p class="sn" @click="alterInputClick('reportNo','报告编号')">
          编号：<span>{{ value.reportNo }}</span>
        </p>
        <table class="p1">
          <tr>
            <td width="22%"><p>产品编号</p></td>
            <td colspan="3">
              <p>{{ value.pronum }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('productName','产品名称')">产品名称</p></td>
            <td width="30%" @click="alterInputClick('productName','产品名称')">
              <p>{{ value.productName }}</p>
            </td>
            <td width="18%"><p @click="alterInputClick('volume','容积（L）')">容积（L）</p></td>
            <td width="30%" @click="alterInputClick('volume','容积（L）')">
              <p>{{ value.volume }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('pressure','设计压力（MPa）')">设计压力（MPa）</p></td>
            <td @click="alterInputClick('pressure','设计压力（MPa）')">
              <p>{{ value.pressure }}</p>
            </td>
            <td><p @click="alterInputClick('testMedium','试验介质')">试验介质</p></td>
            <td @click="alterInputClick('testMedium','试验介质')">
              <p>{{ value.testMedium }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('gaugeNo','压力表编号')">压力表编号</p></td>
            <td colspan="3" @click="alterInputClick('gaugeNo','压力表编号')">
              <p>{{ value.gaugeNo }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('validDate','压力表检验有效期')">压力表检验有效期</p></td>
            <td @click="alterInputClick('validDate','压力表检验有效期')">
              <p>{{ value.validDate }}</p>
            </td>
            <td><p @click="alterInputClick('accuracy','压力表精度等级')">压力表精度等级</p></td>
            <td @click="alterInputClick('accuracy','压力表精度等级')">
              <p>{{value.accuracy}}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('diameter','压力表表盘直径（mm）')">压力表表盘直径（mm）</p></td>
            <td @click="alterInputClick('diameter','压力表表盘直径（mm）')">
              <p>{{ value.diameter }}</p>
            </td>
            <td><p @click="alterInputClick('range','压力表量程（MPa）')">压力表量程（MPa）</p></td>
            <td @click="alterInputClick('range','压力表量程（MPa）')">
              <p>{{ value.range }}</p>
            </td>
          </tr>
          <tr>
            <td><p @click="alterInputClick('environmentTemperature','环境温度（℃）')">环境温度（℃）</p></td>
            <td @click="alterInputClick('environmentTemperature','环境温度（℃）')">
              <p>{{ value.environmentTemperature }}</p>
            </td>
            <td><p @click="alterInputClick('mediumTemperature','介质温度（℃）')">介质温度（℃）</p></td>
            <td @click="alterInputClick('mediumTemperature','介质温度（℃）')">
              <p>{{ value.mediumTemperature }}</p>
            </td>
          </tr>
        </table>
        <table class="p2">
          <tr>
            <td width="7%"><p>设计要求水压试验曲线</p></td>
            <td>
              <div class="img-wrapper">
                <p class="float-temp1-1 ft" @click="alterInputClick('designPressure','要求试验压力')">{{value.designPressure}}P</p>
                <p class="float-time1-1 ft" @click="alterInputClick('designTime','要求保压时间')">{{value.designTime}}min</p>
                <img :src="img1" alt="" style="height:120pt;"/>
              </div>
            </td>
          </tr>
          <tr>
            <td><p>实际水压试验曲线</p></td>
            <td>
              <div class="img-wrapper">
                <p class="float-temp1-1 ft" @click="alterInputClick('operatePressure','实际试验压力')">{{value.operatePressure}}MPa</p>
                <p class="float-time1-1 ft" @click="alterInputClick('operateTime','实际保压时间')">{{value.operateTime}}min</p>
                <img :src="img1" alt="" style="height:120pt;"/>
              </div>
            </td>
          </tr>
        </table>
        <div class="p3">
        <p>结  论：</p>
        <p style="text-indent:24pt;">根据《蓄能压力容器》GB/T 20663的8.5项规定检验，共
          <span>{{value.amount}}</span>
          台壳体经
          <span>{{value.operatePressure}}</span>
          MPa的水压试验，保压
          1
          分钟以上无变形和泄漏等异常现象，试验结论为合格。</p>
        </div>
        <div class="p4">
          <p class="sign-title" style="margin-top:10pt;margin-bottom:10pt;">
            <span @click="alterSelectClick('sign1','监检员签名')" class="sign-title" style="margin-right:100pt;">监检员：<span class="sign-img" v-show="value.sign1"><img :src="urlTrans(value.sign1)" alt="" style="width:90pt;height:34pt;"></span></span>
            <span @click="alterSelectClick('sign2','检验员签名')" class="sign-title" style="margin-right:100pt;">检验员：<span class="sign-img" v-show="value.sign2"><img :src="urlTrans(value.sign2)" alt="" style="width:90pt;height:34pt;"></span></span>
            <span @click="alterSelectClick('sign3','检验与试验责任人签名')" class="sign-title">检验与试验责任人：<span class="sign-img1" v-show="value.sign3"><img :src="urlTrans(value.sign3)" alt="" style="width:90pt;height:34pt;"></span></span>
          <p class="date" @click="alterInputClick('reportDate','报告日期','date')"> 日期：{{value.reportDate}}</p>
        </div>
      </div>
    </div>
    </div>

    <Modal v-model="modalValue.alterValue" :width="1000" :mask-closable="false">
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{ value.reportNo }}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td>
                <span> {{ currentText }}： </span>
              </td>
              <td style="text-align: left">
                <select v-model="currentValue">
                  <option
                    :value="item.url"
                    v-for="(item, index) in signatureList"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterSubmit">确定</Button>
        <Button size="large" @click="closeModal('alterValueSelect')"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "heatReport",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
    this.getContent();
    this.getStaticOptionsData();
  },
  data() {
    return {
      value: {},
      pronumList:[],
      printParams: {
        id: "to_single_print",
        popTitle: "",
      },
      fid: 0,
      modalValue: {
        alterValue: false,
        alterValueSelect: false,
      },
      currentValue: "",
      currentKey: "",
      currentText: "",
      currentType: "text",
      signatureList: [],
      img1: process.env.BASE_URL + "img/hy1.jpg",
    };
  },
  methods: {
    getStaticOptionsData() {
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: "signatureList",
        })
        .then((response) => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          } else {
            this.$Message.warning("请求选项数据失败！");
          }
        })
        .catch((error) => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "normalReport",
          enid: this.fileId,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.value = response.data.content;
            this.$forceUpdate();
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    alterInputClick(key, text, t = "text") {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal("alterValue");
    },
    alterSelectClick(key, text) {
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal("alterValueSelect");
    },
    alterSubmit() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid: this.fid,
          currentValue: this.currentValue,
          currentKey: this.currentKey,
        })
        .then((response) => {
          if (response.data.stat == "ok") {
            this.closeModal("alterValue");
            this.closeModal("alterValueSelect");
            this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label) {
      this.modalValue[label] = true;
    },
    closeModal(label) {
      this.modalValue[label] = false;
    },
    urlTrans(url) {
      return this.$fileUrlFac(url, authData.sfileRight);
    },
  },
  computed: {},
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper {
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;
  text-align: center;
  position: relative;
  margin: 1px;
  overflow: hidden;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    margin-bottom: 10px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title {
  font-size: 14pt;
}

.content p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 5pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p {
  line-height: 14pt !important;
}

.free-text {
  text-align: left;
  padding: 3pt 10pt;
}

.underline {
  display: inline-block;
  width: 80pt;
  border-bottom: 1px solid #333;
  line-height: 14pt;
  text-align: center;
}

.w1 {
  border: 1px solid #333;
  padding: 10pt;
}

.sub-title {
  margin-top: 30pt;
  text-align: center;
  font-size: 16pt !important;
  font-weight: 600;
  margin-bottom: 10pt;
}

.sign {
  margin-top: 10pt;
  text-align: right;
}

.p1,
.p2,
.p3,
.w1,
.p4,
.p5 {
  border: 1px solid #333;
}

.p1 td {
  padding: 9pt 0;
}

.p1 p {
  line-height: 1.2;
}

.s-line {
  position: relative;
  bottom: 0.5pt;
}

.sign-span {
  margin-right: 100pt;
  position: relative;
}

.sign-img {
  position: absolute;
  left:35pt;
  top:-8pt;
  z-index: 10;
}

.sign-img1 {
  position: absolute;
  left:85pt;
  top:-8pt;
  z-index: 10;
}

.sign-item {
  position: absolute;
  left: 50pt;
  white-space: nowrap;
}

.date-span {
  margin-right: 60pt;
  position: relative;
}

.date-item {
  position: absolute;
  left: 30pt;
  white-space: nowrap;
}

.inner-content-wrapper {
  margin: 0 auto;
  width: fit-content;
}

table.base td {
  border: none;
}

input {
  border: none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}

table.p2 td{
  height:28pt;
}

table.p2 td p{
  line-height: 1.2;
}

.p3 {
  border-top:none;
  border-bottom: none;
}


div.p3,div.p4{
  padding: 2pt 10pt;
  position: relative;
}



.sign-title {
  text-align: left;
  position: relative;
}

.sign-mark {
  text-align: right;
}

.result {
  text-align: left;
  text-indent: 24pt;
}

table.p5 td {
  padding: 0pt 0;
  height:24pt;
}

.page {
  text-align: right;
  color: #999;
  padding-top: 5pt;
  padding-right: 5pt;
}

.float-temp1-1{
  top:26pt;
  left:150pt;
}
.float-time1-1{
  top:97pt;
  left:160pt;
}

.ft{
  position: absolute;
  font-size: 13pt !important;
}

.stamp{
  margin-top:20pt;
  text-align: right;
  padding-right:100pt;
}

.date{
  text-align: right;
  padding-right:60pt;
}
.img-wrapper{
  position: relative;
}

.p3 p{
  text-align: left;
  line-height: 2;
  font-size: 11pt;
}

.p4 p{
  font-size: 11pt;
}

</style>